import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(null);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => {
    setMenuOpen(false);
    setDropdownOpen(null);
  };
  const toggleDropdown = (dropdown) => {
    setDropdownOpen(dropdownOpen === dropdown ? null : dropdown);
  };

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownOpen && !event.target.closest('.relative')) {
        setDropdownOpen(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropdownOpen]);

  return (
    <nav className="w-full bg-white shadow-lg fixed top-0 left-0 z-50 border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-6 py-5 flex items-center justify-between">
        
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2 group">
          <img src="/logo.png" alt="PAK School Logo" className="h-10 w-auto transition-transform duration-300 group-hover:scale-105" />
          
        </Link>

        {/* Desktop Menu */}
        <div
          className={`md:flex md:items-center md:gap-6 absolute md:static left-0 w-full md:w-auto bg-white transition-all duration-500 ease-in-out ${
            menuOpen
              ? "top-16 opacity-100 shadow-lg md:shadow-none"
              : "top-[-500px] opacity-0 md:opacity-100"
          }`}
        >
          {/* Home */}
          <Link
            to="/"
            onClick={closeMenu}
            className="relative block py-3 px-6 md:p-0 text-gray-800 font-bold group hover:text-blue-600 transition-all duration-300 text-sm tracking-wider uppercase"
          >
            Home
            <span className="absolute left-0 bottom-0 w-0 h-[3px] bg-gradient-to-r from-blue-600 to-red-500 transition-all duration-300 group-hover:w-full rounded-full"></span>
          </Link>

          {/* About */}
          <Link
            to="/about"
            onClick={closeMenu}
            className="relative block py-3 px-6 md:p-0 text-gray-800 font-bold group hover:text-blue-600 transition-all duration-300 text-sm tracking-wider uppercase"
          >
            About Us
            <span className="absolute left-0 bottom-0 w-0 h-[3px] bg-gradient-to-r from-blue-600 to-red-500 transition-all duration-300 group-hover:w-full rounded-full"></span>
          </Link>

          {/* Academics Dropdown */}
          <div className="relative">
            <button
              onClick={() => toggleDropdown('academics')}
              className="relative block py-3 px-6 md:p-0 text-gray-800 font-bold group hover:text-blue-600 transition-all duration-300 text-sm tracking-wider uppercase flex items-center"
            >
              Academics
              <i className={`fas fa-chevron-down ml-1 text-xs transition-transform duration-300 ${dropdownOpen === 'academics' ? 'rotate-180' : ''}`}></i>
              <span className="absolute left-0 bottom-0 w-0 h-[3px] bg-gradient-to-r from-blue-600 to-red-500 transition-all duration-300 group-hover:w-full rounded-full"></span>
            </button>
            
            {dropdownOpen === 'academics' && (
              <div className="absolute top-full left-0 mt-2 w-64 bg-white rounded-lg shadow-lg border border-gray-200 py-2 z-50">
                <Link
                  to="/academics"
                  onClick={closeMenu}
                  className="block px-4 py-2 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors"
                >
                  <i className="fas fa-graduation-cap mr-2"></i>Academic Overview
                </Link>
                <Link
                  to="/syllabus"
                  onClick={closeMenu}
                  className="block px-4 py-2 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors"
                >
                  <i className="fas fa-book-open mr-2"></i>Syllabus
                </Link>
                <Link
                  to="/booklist"
                  onClick={closeMenu}
                  className="block px-4 py-2 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors"
                >
                  <i className="fas fa-books mr-2"></i>Book Lists
                </Link>
                <Link
                  to="/curriculum"
                  onClick={closeMenu}
                  className="block px-4 py-2 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors"
                >
                  <i className="fas fa-graduation-cap mr-2"></i>Curriculum
                </Link>
                <Link
                  to="/results"
                  onClick={closeMenu}
                  className="block px-4 py-2 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors"
                >
                  <i className="fas fa-chart-line mr-2"></i>Results
                </Link>
            <Link
                  to="/orientations"
              onClick={closeMenu}
                  className="block px-4 py-2 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors"
                >
                  <i className="fas fa-calendar-alt mr-2"></i>Orientations
                </Link>
              </div>
            )}
          </div>

          {/* Activities Dropdown */}
          <div className="relative">
            <button
              onClick={() => toggleDropdown('activities')}
              className="relative block py-3 px-6 md:p-0 text-gray-800 font-bold group hover:text-blue-600 transition-all duration-300 text-sm tracking-wider uppercase flex items-center"
            >
              Activities
              <i className={`fas fa-chevron-down ml-1 text-xs transition-transform duration-300 ${dropdownOpen === 'activities' ? 'rotate-180' : ''}`}></i>
              <span className="absolute left-0 bottom-0 w-0 h-[3px] bg-gradient-to-r from-blue-600 to-red-500 transition-all duration-300 group-hover:w-full rounded-full"></span>
            </button>
            
            {dropdownOpen === 'activities' && (
              <div className="absolute top-full left-0 mt-2 w-64 bg-white rounded-lg shadow-lg border border-gray-200 py-2 z-50">
                <Link
                  to="/gallery"
                  onClick={closeMenu}
                  className="block px-4 py-2 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors"
                >
                  <i className="fas fa-images mr-2"></i>Gallery
                </Link>
                <Link
                  to="/daily-media"
                  onClick={closeMenu}
                  className="block px-4 py-2 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors"
                >
                  <i className="fas fa-camera mr-2"></i>Daily Media
                </Link>
                <Link
                  to="/sports"
                  onClick={closeMenu}
                  className="block px-4 py-2 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors"
                >
                  <i className="fas fa-trophy mr-2"></i>Sports Corner
                </Link>
              </div>
            )}
          </div>

          {/* Admission */}
          <Link
            to="/admission"
            onClick={closeMenu}
            className="relative block py-3 px-6 md:p-0 text-gray-800 font-bold group hover:text-blue-600 transition-all duration-300 text-sm tracking-wider uppercase"
          >
            Admission
            <span className="absolute left-0 bottom-0 w-0 h-[3px] bg-gradient-to-r from-blue-600 to-red-500 transition-all duration-300 group-hover:w-full rounded-full"></span>
          </Link>

          {/* Contact */}
          <Link
            to="/contact"
            onClick={closeMenu}
            className="relative block py-3 px-6 md:p-0 text-gray-800 font-bold group hover:text-blue-600 transition-all duration-300 text-sm tracking-wider uppercase"
          >
            Contact Us
              <span className="absolute left-0 bottom-0 w-0 h-[3px] bg-gradient-to-r from-blue-600 to-red-500 transition-all duration-300 group-hover:w-full rounded-full"></span>
            </Link>
        </div>

        {/* Button (optional) */}
        <Link
          to="/admission"
          className="hidden md:inline-block bg-gradient-to-r from-blue-600 to-blue-700 text-white px-6 py-2.5 rounded-full shadow-lg hover:shadow-xl hover:from-blue-700 hover:to-blue-800 transition-all duration-300 font-bold text-sm tracking-wider uppercase"
        >
          Apply Now
        </Link>

        {/* Hamburger Menu */}
        <div
          onClick={toggleMenu}
          className="md:hidden flex flex-col gap-[5px] cursor-pointer"
        >
          <span
            className={`w-6 h-[2px] bg-gray-800 transition-all duration-300 ${
              menuOpen ? "rotate-45 translate-y-[6px]" : ""
            }`}
          ></span>
          <span
            className={`w-6 h-[2px] bg-gray-800 transition-all duration-300 ${
              menuOpen ? "opacity-0" : ""
            }`}
          ></span>
          <span
            className={`w-6 h-[2px] bg-gray-800 transition-all duration-300 ${
              menuOpen ? "-rotate-45 -translate-y-[6px]" : ""
            }`}
          ></span>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
